'use client';

import { XIcon } from '@/components/Icons/Icons';

interface ModalCloseButtonProps {
  onClick?: () => void;
}

/**
 * The close (X) button every login/logout modal renders inside its own content, at a fixed
 * position independent of the dialog's layout. This is NOT the generic close button
 * `CommonModal`/`DialogContent` can render itself via `showCloseButton` (see
 * components/ui/dialog.tsx) — pass `showCloseButton={false}` on the `CommonModal` wrapper
 * when using this, or both render at once (that pairing shipped once, on the registration
 * modal, and produced two overlapping close buttons).
 */
export function ModalCloseButton({ onClick }: ModalCloseButtonProps) {
  return (
    <button
      onClick={onClick}
      className="absolute cursor-pointer top-3 right-3 tab:top-3 tab:right-3 desktop:top-4 desktop:right-4 z-20 rounded-xs opacity-70 ring-offset-background transition-opacity hover:opacity-100 disabled:pointer-events-none touch-manipulation"
      aria-label="Close"
    >
      <XIcon size={16} className="text-text-default-strong" />
    </button>
  );
}
